var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('headmenu'),_c('div',{staticClass:"service"},[_vm._m(0),_c('div',{staticClass:"text"},[_c('span',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.details)}})])])]),_c('Footer')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('h1',[_vm._v("会员服务")]),_c('div',{staticClass:"line"})])
}]

export { render, staticRenderFns }